export default __webpack_public_path__ + "static/continuous-compliance1-f5553e95901432391364fb2401ea05b6.jpg";